import React, { createContext, useContext, useState, useEffect } from "react";
import DeveloperConsole from "../components/DeveloperConsole";
import { MODE } from "../config/runtime";

const DevLogContext = createContext();

export const DevLogProvider = ({ children }) => {
  const [logs, setLogs] = useState([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handleKeyDown = e => {
      if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "l") {
        setOpen(prev => !prev);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const addDevLog = (message, type = "info") => {
    setLogs(prev => [
      ...prev,
      { message, type, time: new Date().toLocaleTimeString() },
    ]);
    console.log(`[${type.toUpperCase()}]`, message);
  };

  const clearLogs = () => setLogs([]);
  console.log("MODE:", MODE);

  return (
    <DevLogContext.Provider value={{ addDevLog, clearLogs }}>
      {children}

      {(MODE === "development" || MODE === "staging" || MODE === "local") &&
        open && <DeveloperConsole logs={logs} clearLogs={clearLogs} />}
    </DevLogContext.Provider>
  );
};

export const useDevLogger = () => useContext(DevLogContext);
